import { statusState } from '@/stores/index.js'

let evtSource

if (!!window.EventSource && !process.env.DISABLE_SSE) {
  let evtSourceBackend = window.location.protocol + '//' + window.location.host.split(':')[0] + "/api/v1/watchEvents"

  switch (process.env.DEMO_MODE + process.env.DEV_MODE) {
    case 'falsetrue':
      evtSourceBackend = window.location.protocol + '//' + window.location.host.split(':')[0] + ':5860/api/v1/watchEvents'
      break

    case 'truefalse':
    case 'truetrue':
      evtSourceBackend = window.location.protocol + '//' + window.location.host + '/api/v1/watchEvents'
      break
  }

  evtSource = new EventSource(evtSourceBackend,
    {
      //withCredentials: true
    }
  )
  console.log('[*] evtSource.withCredentials:', evtSource.withCredentials)
  console.log('[*] evtSource.readyState:', evtSource.readyState)
  console.log('[*] evtSource.url:', evtSource.url)
}
else if (process.env.DISABLE_SSE) {
  console.error('[*] SSE disabled!')
}
else {
  throw Error('[*] No SSE!')
}

console.log('[*] DISABLE_SSE:', process.env.DISABLE_SSE)
console.log('[*] DEMO_MODE:', process.env.DEMO_MODE)
console.log('[*] DEV_MODE:', process.env.DEV_MODE)
console.log('[*] BACKEND_URL:', process.env.BACKEND_URL)

const maxReconnect = 5
let responseInterceptor = false,
  reconnectCount = 0

export const watchEvents = clientId => {
  console.log('[*] Watching for event:', clientId)

  if (evtSource) {
    evtSource.onopen = () => {
      reconnectCount = 0
      console.log('[*] SSE connection open')
    }

    evtSource.onerror = err => {
      console.error('[*] EventSource failed:', err)
      if (reconnectCount > maxReconnect) {
        evtSource.close()
        console.log('[*] Event source reconnect attempt exceeds max try')
      } else {
        reconnectCount++
      }
    }

    // Send to client on event
    evtSource.addEventListener(clientId, message => {
      statusState.updateStatus(JSON.parse(message.data))
    })
  }

  console.log(evtSource)
}
